export const Events = {
  // Onboarding & Core
  OnboardingStart: 'onboarding_start',
  OnboardingComplete: 'onboarding_complete',
  OnboardingSelectReasons: 'onboarding_select_reasons',
  PlanGenerateClicked: 'plan_generate_clicked',
  PlanGenerated: 'plan_generated',
  
  // Swipe interactions
  SwipeRight: 'swipe_right',
  SwipeLeft: 'swipe_left', 
  SwipeUp: 'swipe_up',
  SwipeDown: 'swipe_down',
  
  // Billing & Checkout
  CheckoutStarted: 'checkout_started',
  CheckoutCompleted: 'checkout_completed',
  HardWallHit: 'hard_wall_hit',
  UpgradePlanClick: 'upgrade_plan_click',
  EditProfileClick: 'edit_profile_click',
  DownloadInvoiceClick: 'download_invoice_click',
  ConnectCalendarClick: 'connect_calendar_click',
  DisconnectCalendarClick: 'disconnect_calendar_click',
  BillingPortalOpened: 'billing_portal_opened',
  BillingPortalFailed: 'billing_portal_failed',
  BillingPortalReturn: 'billing_portal_return',
  
  // Pricing
  PricingPageView: 'pricing_page_view',
  PlanSelectClick: 'plan_select_click',
  BillingPeriodToggle: 'billing_period_toggle',
  
  // Recipe interactions
  RecipeAddToPlan: 'recipe_add_to_plan',
  RecipeViewDetails: 'recipe_view_details',
  CreateCustomRecipeClick: 'create_custom_recipe_click',
  RecipesLoadMore: 'recipes_load_more',
  
  // Modal interactions
  HowItWorksOpened: 'how_it_works_opened',
  HowItWorksCTAClick: 'how_it_works_cta_click',
  
  // Email verification
  ResendVerificationSuccess: 'resend_verification_success',
  ResendVerificationFail: 'resend_verification_fail',
} as const;

export type EventName = typeof Events[keyof typeof Events];